import React from 'react';
import {
  ApartmentOutlined,
  GroupOutlined,
  ImportOutlined,
  SolutionOutlined,
} from '@ant-design/icons';

import { getMenuAdminAccountConfiguration } from '@totem/components/ui_components/menus/mainMenu/admin_account_configuration';
import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import IBDIcon from '@totem/styles/Icon';
import { UserProfile } from '@totem/types/user';

export const getMenuAdminAccount = (userProfile: UserProfile) => {
  const items: IBMenuItem[] = [
    {
      key: 'contacts',
      title: 'Contacts',
      label: 'Contacts',
      description: 'Organization Contacts',
      route: '/dashboard/account/contacts',
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return permissions.systemAdministrator.hasPermissions(userProfile);
      },
    },
    {
      key: 'users',
      title: 'Users',
      label: 'Users',
      description: 'User Administration',
      route: '/dashboard/usermanagement',
      icon: <IBDIcon name="Users" />,
      hasPermissions: () => {
        return permissions.organizationalAdministrator.hasPermissions(
          userProfile,
        );
      },
    },
    {
      key: 'accountPlan',
      title: 'Account Plan',
      label: 'Account Plan',
      description:
        'Internal operational + sales account plan for this organization',
      route: '/dashboard/admin/accountPlan',
      icon: <SolutionOutlined />,
      hasPermissions: () => {
        return permissions.internal.hasPermissions(userProfile);
      },
    },
    {
      key: 'orgChart',
      title: 'Org Chart',
      label: 'Org Chart',
      description: 'Stakeholder reporting structure from the account plan',
      route: '/dashboard/account/orgChart',
      icon: <ApartmentOutlined />,
      hasPermissions: () => {
        return permissions.internal.hasPermissions(userProfile);
      },
    },
    {
      key: 'salesOrders',
      title: 'Sales Orders',
      label: 'Sales Orders',
      description: 'Sales Order Lines',
      route: '/dashboard/account/salesOrders',
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return permissions.contractsViewer.hasPermissions(userProfile);
      },
    },
    {
      key: 'accountServices',
      title: 'Services',
      label: 'Services',
      description: 'Services',
      route: '/dashboard/account/services',
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return permissions.systemAdministrator.hasPermissions(userProfile);
      },
    },
    {
      key: 'tenants',
      title: 'Tenants',
      label: 'Tenants',
      description: 'Organization Tenant Management',
      route: '/dashboard/tenants',
      icon: <GroupOutlined />,
      hasPermissions: () => {
        return permissions.organizationalAdministrator.hasPermissions(
          userProfile,
        );
      },
    },
    {
      key: 'configuration',
      title: 'Configuration',
      label: 'Configuration',
      description: 'Organization Configuration',
      route: '/dashboard/account/configuration',
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return getMenuAdminAccountConfiguration(userProfile).length > 0;
      },
    },
  ];

  return items.filter((chk) => chk.hasPermissions(userProfile));
};
